import { InjectionToken } from "@angular/core";

export interface MapSearchEndpoints {
    omniSearch: string;
}

export const MAP_SEARCH_ENDPOINTS = new InjectionToken<MapSearchEndpoints>("Map Search Token");
